import { render, staticRenderFns } from "./ReviewsAnalystRatingsChartLegend.vue?vue&type=template&id=0587bd44&scoped=true&"
import script from "./ReviewsAnalystRatingsChartLegend.vue?vue&type=script&lang=js&"
export * from "./ReviewsAnalystRatingsChartLegend.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsAnalystRatingsChartLegend.vue?vue&type=style&index=0&id=0587bd44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0587bd44",
  null
  
)

export default component.exports